import {
  beRecipientGetGroupDetails,
  beRecipientGetListOfGroupDetails,
  GROUP_TYPE_TEST,
  GROUPS_SEARCH_TYPE_ECONTAINS
} from 'Api/beRecipientApi'

import { INPUT_GROUPS_MAX_ITEMS } from 'Constants/'

import memo from 'Helpers/memo'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

const makeGroupItem = ({ Id, Name, Notes }) => ({
  label: Notes ? `${Id} - ${Name} (${Notes})` : `${Id} - ${Name}`,
  value: Id
})

async function fetchGroups(searchBy) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: INPUT_GROUPS_MAX_ITEMS,
    groupType: undefined,
    searchBy,
    searchType: searchBy ? GROUPS_SEARCH_TYPE_ECONTAINS : undefined
  })

  return {
    items: Items.map((o) => makeGroupItem(o)),
    totalItems: TotalItems
  }
}

async function fetchTestGroups(searchBy) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: INPUT_GROUPS_MAX_ITEMS,
    groupType: GROUP_TYPE_TEST,
    searchBy,
    searchType: searchBy ? GROUPS_SEARCH_TYPE_ECONTAINS : undefined
  })

  return {
    items: Items.map((o) => makeGroupItem(o)),
    totalItems: TotalItems
  }
}

export const getGroups = memo(fetchGroups)
export const getTestGroups = memo(fetchTestGroups)

export async function getGroupById(idGroup) {
  const result = await beRecipientGetGroupDetails(idGroup)

  return result ? makeGroupItem(result) : null
}

export { GROUP_TYPE_TEST }
